import React from 'react';
import CommonGuestLayout from '../../../../../shared/email-services/common-guest-layout/CommonGuestLayout';

const GuestLayout = (props) => {
  const {
    setActiveSection,
    activeSection,
    componentsList,
    setComponentsList,
    onClickComponent,
    onClickBack,
    getImageAligin,
    setIsDragged,
    isDragged,
  } = props;

  const onComponentDrop = (e) => {
    const component = JSON.parse(e.dataTransfer.getData('component'));
    const currComponentsList = [...componentsList.body];
    currComponentsList.push({
      title: component.componentTitle ? component.componentTitle : component.title,
      id: component.id,
      subId: component.subId,
    });
    setComponentsList({ body: currComponentsList });
    setIsDragged(false);
  };

  const reorder = (list, sourceIndex, destinationIndex) => {
    const result = [...list];
    const [removed] = result.splice(sourceIndex, 1);
    result.splice(destinationIndex, 0, removed);
    return result;
  };

  const onDragEnd = (dragResult) => {
    if (!dragResult.destination) return;
    const reorderedComponents = reorder(
      componentsList.body,
      dragResult.source.index,
      dragResult.destination.index,
    );
    const newReOrder = reorderedComponents.map((currOrder, ordIndx) => {
      const currData = { ...currOrder };
      currData.index = ordIndx;
      return { ...currData };
    });
    setComponentsList({ body: newReOrder });
  };

  const onSetActiveSection = (e, currActiveSection) => {
    setActiveSection(currActiveSection);
    onClickBack(e);
  };

  return (
    <CommonGuestLayout
      activeSection={activeSection}
      onSetActiveSection={onSetActiveSection}
      componentsList={componentsList}
      getImageAligin={getImageAligin}
      setActiveSection={setActiveSection}
      onComponentDrop={onComponentDrop}
      onDragEnd={onDragEnd}
      onClickComponent={onClickComponent}
      isPreview={false}
      isMobilePreview={false}
      isDragged={isDragged}
    />
  );
};

export default GuestLayout;
